import React from 'react';
import SubscribersPanelContainer from './SubscribersPanelContainer';
import SubscribersTable from './SubscribersTable';

const SubscribersPanelFull = ({
  code,
  category,
  onChange,
  url,
}) => (
  <SubscribersPanelContainer
    category={category}
    className="aridhia-subscribers-panel-full"
    code={code}
    onChange={onChange}
    url={url}
  >
    <SubscribersTable category={category} code={code} />
  </SubscribersPanelContainer>
);

export default SubscribersPanelFull;
